import { render } from "./GroupCreateComponent.vue?vue&type=template&id=3bcd587b&scoped=true"
import script from "./GroupCreateComponent.vue?vue&type=script&lang=js"
export * from "./GroupCreateComponent.vue?vue&type=script&lang=js"

import "./GroupCreateComponent.vue?vue&type=style&index=0&id=3bcd587b&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bcd587b"]])

export default __exports__